export class SetLocaleVariableContent {
  static readonly type = '[LocaleVariable] Set Locale Variable Content';
  constructor(public content: { [key: string]: string } | null) {}
}
